export * from './services/LocalStorageService';

//# sourceMappingURL=LocalStorageService.js.map
